<div *ngIf="controlDir" class="pl-textarea flex flex-col gap-0.5">
  <label [for]="identifier" class="mb-2 whitespace-normal break-words text-lg font-bold text-pl-gray-700">
    {{ label | plSlice: 200 }}
  </label>

  <div class="flex justify-between gap-2">
    <div
      tabindex="1"
      #inputElement
      [editable]="!isDisabled"
      [attr.placeholder]="placeholder"
      [(ngModel)]="value"
      (ngModelChange)="onChange()"
      (focus)="onCustomInputFocus()"
      (blur)="onBlur()"
      [ngClass]="{
        '!border-pl-error caret-pl-error placeholder:text-pl-error':
          showBorderValidationColor && controlDir.invalid && controlDir.dirty && isFormSubmitted,
        '!border-pl-green-500': showBorderValidationColor && controlDir.valid && controlDir.dirty,
        'focus:border-pl-blue-500 focus:bg-pl-gray-100': !isDisabled,
        'whitespace-normal break-words bg-pl-gray-300 text-pl-gray-500': isDisabled,
        'max-h-60': height === TextAreaHeight.medium,
        'max-h-96': height === TextAreaHeight.large
      }"
      unformattedPaste="true"
      class="content-editable inline-block min-h-[8rem] w-full overflow-y-auto whitespace-pre-wrap rounded-md border-2 border-pl-gray-700 p-4 px-2.5 py-2.5 font-sans text-lg text-pl-gray-450 outline-none"
    ></div>

    <pl-icon-custom-control
      *ngIf="showRightIcon"
      [isDirty]="!!controlDir.dirty"
      [isFocused]="isFocused"
      [isValid]="!!controlDir.valid"
      [isDisabled]="isDisabled"
      [isFormSubmitted]="isFormSubmitted"
    />
  </div>
  <ng-container *ngIf="controlDir.errors && controlDir.dirty && isFormSubmitted">
    <p
      class="text-xs text-pl-error"
      *ngIf="
        controlDir.errors[CustomValidatorErrors.minNumberWords] || controlDir.errors[CustomValidatorErrors.maxlength]
      "
    >
      <span *ngIf="controlDir.errors[CustomValidatorErrors.minNumberWords]">
        {{ 'blocks.textarea.errorMinNumberWords' | translate: { minNumberWords: minNumberWords } }}
      </span>
      <span *ngIf="controlDir.errors[CustomValidatorErrors.maxlength]">
        {{ 'errors.max_characters' | translate: { max: controlDir.control?.errors?.['maxlength'].requiredLength } }}
      </span>
    </p>
  </ng-container>
</div>
